export const formatHour = (date?: Date) => {
  return `${String(date?.getHours()).padStart(2, '0')}:${String(date?.getMinutes()).padStart(2, '0')}`;
};
